import { KeyRound } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { TONES } from '@/lib/tones';
import { cn } from '@/lib/utils';

export const PhysicalAccessKeyIcon = ({
  granted,
  className,
}: {
  granted: boolean;
  className?: string;
}) => {
  const { t } = useTranslation();
  const statusLabel = t(
    granted
      ? 'physical-office-access.granted'
      : 'physical-office-access.not-granted',
  );
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className="inline-flex"
          role="img"
          aria-label={statusLabel}
        >
          <KeyRound
            aria-hidden="true"
            className={cn(
              'size-3',
              granted
                ? `fill-emerald-500/30 ${TONES.emerald.text}`
                : 'text-muted-foreground/60',
              className,
            )}
            strokeDasharray={granted ? undefined : '2 2'}
          />
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <span>{statusLabel}</span>
      </TooltipContent>
    </Tooltip>
  );
};
